import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enBuilder from './locales/en/builder.json';
import enAdmin from './locales/en/admin.json';
import enAnalytics from './locales/en/analytics.json';
import enBilling from './locales/en/billing.json';
import enTracking from './locales/en/tracking.json';
import enShortLinks from './locales/en/shortLinks.json';
import enDevDoc from './locales/en/devDoc.json';
import enHome from './locales/en/home.json';

import thCommon from './locales/th/common.json';
import thAuth from './locales/th/auth.json';
import thDashboard from './locales/th/dashboard.json';
import thBuilder from './locales/th/builder.json';
import thAdmin from './locales/th/admin.json';
import thAnalytics from './locales/th/analytics.json';
import thBilling from './locales/th/billing.json';
import thTracking from './locales/th/tracking.json';
import thShortLinks from './locales/th/shortLinks.json';
import thDevDoc from './locales/th/devDoc.json';
import thHome from './locales/th/home.json';

export const SUPPORTED_LANGUAGES = ['en', 'th'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';
export const LANGUAGE_STORAGE_KEY = 'app.language';

export const NAMESPACES = [
  'common',
  'auth',
  'dashboard',
  'builder',
  'admin',
  'analytics',
  'billing',
  'tracking',
  'shortLinks',
  'devDoc',
  'home',
] as const;

export const DEFAULT_NAMESPACE = 'common';

export const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    builder: enBuilder,
    admin: enAdmin,
    analytics: enAnalytics,
    billing: enBilling,
    tracking: enTracking,
    shortLinks: enShortLinks,
    devDoc: enDevDoc,
    home: enHome,
  },
  th: {
    common: thCommon,
    auth: thAuth,
    dashboard: thDashboard,
    builder: thBuilder,
    admin: thAdmin,
    analytics: thAnalytics,
    billing: thBilling,
    tracking: thTracking,
    shortLinks: thShortLinks,
    devDoc: thDevDoc,
    home: thHome,
  },
} as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    defaultNS: DEFAULT_NAMESPACE,
    ns: NAMESPACES as unknown as string[],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ['localStorage'],
    },
    returnNull: false,
  });

const updateHtmlLang = (lng: string) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
};

updateHtmlLang(i18n.language || DEFAULT_LANGUAGE);
i18n.on('languageChanged', updateHtmlLang);

export default i18n;
